export default function objSet(obj, path, value) {
	if (!path) return;

	let parts = path.split('.');
	while (parts.length > 1) {
		let part = parts.shift();
		obj = obj[part];
	}
	let [part] = parts;
	obj[part] = value;
}